<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column
            h1.is-size-3
              | {{ title }}
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-6
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie | resguarda | ubicación | Oficina | Descripción | Partida | No Parte',
                  v-model="query_consumibles",
                )
          .column.is-3(v-show="resultadoFilter !== ''")
            span.tag.is-warning
              | {{ resultadoFilter }}
          .column.has-text-right.is-3(:class="resultadoFilter ? '':'is-offset-3'")
            router-link.a.button.is-black(v-show="permisos.inventarios != 6" to="/Inventario/Consumibles/Nuevo")
              span.icon
                i.fa.fas.fa-plus
              | &nbspConsumible
            | &nbsp
            a.button.is-success(@click="downloadConsumibles")
              span.icon
                i.fa.fas.fa-file-download
              | &nbspDescarga
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12.has-text-centered
            .table-responsive
              table#tbConsumibles.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Descripción
                    th Localización
                    th Partida
                    th Cantidad
                    th Surtir
                tbody
                  tr(v-for="(data, index) in consumiblesShow" :key="index")
                    td
                      a.button.is-black.is-small {{ index + 1 }}
                    td(@click="irConsumibleDetalle(data)")
                      .control
                        .tags.has-addons
                          span.tag.is-black
                            i.fas.fa-tag
                            | &nbsp {{ data.categoria}}
                          span.tag.is-warning(v-show="data.subcategoria") {{ data.subcategoria }}
                      span.tag(v-show="data.marca || data.modelo") {{ data.modelo ? `Marca: ${data.marca} Modelo: ${data.modelo}` : `Marca: ${data.marca}` }}
                    td 
                      div.tags
                        span.tag.is-dark(v-for="l in data.localizaciones") {{ l.localizacion }}
                    td
                      div.tags
                        span.tag.is-dark(v-show="l.noPartida !== ''" v-for="l in data.localizaciones") {{ l.noPartida }}
                    td 
                      span.tag.is-light
                        | {{ data.cantidad }}
                    td(v-html="isSurtible(data)")
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'Consumibles',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: true,
        consumibles: [],
        consumiblesSelect: [],
        consumiblesShow: [],
        hayDatos: false,
        tipos: [],
        almacenes: [],
        origen: {},
        title: '',
        result_query: '',
        query_consumibles: '',
        resultadoFilter: '',
        nombreFile: '',
      }
    },
    watch: {
      query_consumibles() {
        this.resultadoFilter = ''
        if (this.query_consumibles === '') {
          this.consumiblesShow = this.consumiblesSelect
        } else {
          const QUERY_ARTICULOS = this.query_consumibles.toUpperCase()
          const consumibles = this.consumiblesSelect.filter( cons => {
            const partidaArray = []
            cons.localizaciones.map( (item) => { partidaArray.push(item.noPartida)})
            let partidaText= ''
            for (let index = 0; index < partidaArray.length; index++) {
              partidaText += `${partidaArray[index]} `
            }
            const locsArray = []
            cons.localizaciones.map( (item) => { locsArray.push(item.localizacion)})
            let locsText= ''
            for (let index = 0; index < locsArray.length; index++) {
              locsText += `${locsArray[index]} `
            }
            return `${cons.modelo} ${cons.marca} ${cons.categoria} ${cons.subcategoria} ${cons.noParte} ${partidaText} ${locsText}`.toUpperCase().includes(QUERY_ARTICULOS)
          })
          this.consumiblesShow = consumibles
          this.resultadoFilter = `Coinicidencias: ${this.consumiblesShow.length} artículo${this.consumiblesShow.length == 1 ? '' : 's'}`
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAlmacenes()
      },
      obtenerConsumibles () {
        InventarioServices.getConsumiblesAlmacen(this.origen.id_oficina)
          .then(res => {
            this.consumibles = res.map(this.convertirConsumibles)
            this.consumiblesSelect = this.consumibles
            this.consumiblesShow = this.consumiblesSelect
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
          })
      },
      convertirConsumibles (cons) {
        return {
          ...cons,
            id: parseInt(cons.id),
            cantidad: Number(cons.cantidad),
            limite: parseInt(cons.limite),
        }
      },

      irConsumibleDetalle(consumible) {
        this.$store.commit('selectConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Detalle')
      },
      getIndex (x) {
        let indice = parseInt(x) + parseInt(this.limit) + 1
        return `<a class="button is-primary">${indice}</a>`
      },
      isSurtible (consumible) {
        let text = ''
        if (parseInt(consumible.cantidad) <= parseInt(consumible.limite)) {
          text = `<span class="tag is-danger">Es necesario surtir.</span>`
        } else {
          text = `<span class="tag is-light">Aun no es necesario surtir.</span>`
        }
        return text
      },
      backPage () {
        this.$router.back()
      },
      obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
      obtenerAlmacenOrigen() {
        if (this.almacenSelect === 'c') {
          this.almacenes.map( alm => {
            const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
            if (encontrado) {
              this.origen = alm
            }
          })
          this.title = `Consumibles Almacén ${this.origen.clave}`
          this.nombreFile = `Consumibles_${this.origen.ubicacion}`
        } else {
          this.origen = this.almacenes.find( ofi => ofi.clave === this.almacenSelect)
        }
        this.obtenerConsumibles()
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      downloadConsumibles () {
        this.isLoading = true
        InventarioServices.createExcel_consumiblesSedes(this.origen.id_oficina, this.nombreFile)
          .then((res) => {
            const currentUrl = window.location.hostname
            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
              setTimeout(() => {
                InventarioServices.borrarInventario_Ubicacion(res.file)
                  .then( resDel => {
                    this.isLoading = false
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast(e.message, 'ban', 'OK')
                  })
              }, 4000)
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
        
      },
    },
    created () {
      this.iniciarComponente()
      switch (this.almacenSelect) {
        case 'TPA-ALS':
          this.title = 'Consumibles Almacén TPA GIA '
          this.nombreFile = 'Consumibles_GIA_TPA'
          break
        case 'EB04-ALG':
          this.title = 'Consumibles Almacén EB04 GIA '
          this.nombreFile = 'Consumibles_GIA_EB04'
          break
        case 'CORP-ALG':
          this.title = 'Consumibles Almacén Corporativo GIA '
          this.nombreFile = 'Consumibles_GIA_Corporativo'
          break
        case 'IRGE-ALM':
          this.title = 'Consumibles Almacén IRGE '
          this.nombreFile = 'Consumibles_IRGE'
          break
        case 'IRGE-ALA':
          this.title = 'Consumibles Almacén IRGE Activos '
          this.nombreFile = 'Consumibles_IRGE_Activos'
          break
        case 'CORP-ALM':
          this.title = 'Consumibles Almacén Corporativo '
          this.nombreFile = 'Consumibles_Corporativo'
          break
        case 'TPA-ALM':
          this.title = 'Consumibles Almacén TPA '
          this.nombreFile = 'Consumibles_TPA'
          break
        case 'EB04-ALM':
          this.title = 'Consumibles Almacén EB04 '
          this.nombreFile = 'Consumibles_EB04'
          break
        case 'EB00-ALM':
          this.title = 'Consumibles Almacén EB00 '
          this.nombreFile = 'Consumibles_EB00'
          break
        case 'EB01-ALM':
          this.title = 'Consumibles Almacén EB01 '
          this.nombreFile = 'Consumibles_EB01'
          break
        case 'EB02-ALM':
          this.title = 'Consumibles Almacén EB02 '
          this.nombreFile = 'Consumibles_EB02'
          break
        case 'EB03-ALM':
          this.title = 'Consumibles Almacén EB03 '
          this.nombreFile = 'Consumibles_EB03'
          break
        case 'ERM-ALM':
          this.title = 'Consumibles Almacén ERM '
          this.nombreFile = 'Consumibles_ERM'
          break
        }
    },
    computed: {
      ...mapState(['userLogin', 'almacenSelect', 'permisos'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Consumibles.vue